module.exports = "/app/themes/roboyo2021/dist/img/calendar-bk.png?b9993f5bdc877bf21739a24b8feb438f";